var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKucoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41791 12.3669L13.6946 16.5824L16.3941 13.9219C16.8768 13.4936 17.6152 13.5126 18.0745 13.9653C18.5338 14.418 18.5532 15.1458 18.1185 15.6215L14.5562 19.133C14.0777 19.5968 13.3102 19.5968 12.8317 19.133L7.69211 14.0664V17.0779C7.69211 17.7425 7.14543 18.2813 6.47106 18.2813C5.79669 18.2813 5.25 17.7425 5.25 17.0779V7.65194C5.25 6.98731 5.79669 6.44853 6.47106 6.44853C7.14543 6.44853 7.69211 6.98731 7.69211 7.65194V10.6634L12.831 5.59811C13.3094 5.13396 14.0771 5.13396 14.5555 5.59811L18.1205 9.10897C18.5551 9.58469 18.5358 10.3125 18.0765 10.7651C17.6172 11.2178 16.8787 11.2369 16.396 10.8085L13.6966 8.14807L9.41791 12.3669ZM13.6966 11.1621C13.2021 11.1619 12.7562 11.4552 12.5668 11.9054C12.3774 12.3555 12.4818 12.8738 12.8313 13.2185C13.1809 13.5632 13.7067 13.6664 14.1636 13.4799C14.6204 13.2935 14.9183 12.8542 14.9183 12.3669C14.9185 12.0473 14.7899 11.7409 14.5607 11.5148C14.3316 11.2888 14.0208 11.1617 13.6966 11.1615V11.1621Z",
    fill: "#23AF91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoin);
export default __webpack_public_path__ + "static/media/kucoin.ce0b8e979a6b11f6230fb1eaf3279960.svg";
export { ForwardRef as ReactComponent };